export default __webpack_public_path__ + "static/Services-page-0421ca8c017db28803fda2e40acb8f96.png";